module.exports = __webpack_public_path__ + "bo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bo.svg
// module id = 715
// module chunks = 0